// Landing görselleri: sitenin kendi sunucusunda WebP (önceden Emergent'te 1-3 MB PNG).
// Her görselin 800 px ve tam boy sürümü var; tarayıcı ekran genişliğine göre seçer (srcSet).
const gorsel = (ad, tamGenislik) => ({
  src: `/images/landing/${ad}-${tamGenislik}.webp`,
  srcSet: `/images/landing/${ad}-800.webp 800w, /images/landing/${ad}-${tamGenislik}.webp ${tamGenislik}w`,
});

export const LANDING_IMAGES = {
  heroDark: gorsel('hero-koyu', 1448),
  heroLight: gorsel('hero-acik', 1448),
  showcaseDark: gorsel('vitrin-koyu', 1536),
  showcaseLight: gorsel('vitrin-acik', 1536),
  whyDarkTr: gorsel('neden-koyu-tr', 1254),
  whyDarkEn: gorsel('neden-koyu-en', 1254),
  whyLightTr: gorsel('neden-acik-tr', 1254),
  whyLightEn: gorsel('neden-acik-en', 1254),
  ctaMobileDark: gorsel('cta-mobil-koyu', 1254),
  ctaMobileLight: gorsel('cta-mobil-acik', 1254),
  ctaDark: gorsel('cta-koyu', 1718),
  ctaLight: gorsel('cta-acik', 1717),
};
